import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import { GeneralHeader, useWindowDimensions } from "../common";
import { history } from "../../index";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { fetchImageByName } from "../../utils/utility";
import { fontSize } from "../../styles";
import { setGameStage, setGameBlock } from "../../redux/dispatchers";
import { getOptions } from "../../service/api/option";
import { Typography, useTheme } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import RoomIcon from "@material-ui/icons/Room";

const useStyles = makeStyles((theme) => ({
  canvas: {
    height: "100vh",
    width: "100vw",
    position: "fixed",
    overflow: "auto",
  },
  menuDiv: {
    zIndex: 2,
    margin: theme.spacing(1, 1, 0, 7),
    position: "fixed",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    justifyContent: "center",
    transition: "opacity .2s ease",
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(0, 1, 0, 2),
    },
  },
  menuButton: {
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    background: "lightBlue",
    padding: theme.spacing(2, 5, 2, 5),
    fontSize: fontSize.h3,
    fontWeight: "bold",
    color: "black",
    marginTop: theme.spacing(1),
    textTransform: "unset !important",
    marginBottom: theme.spacing(1),
    justifyContent: "flex-start",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1, 3, 1, 3),
      fontSize: fontSize.h4,
    },
    "&:hover": {
      background: "#457B9D",
      color: "black",
    },
  },
  pin: {
    width: 45,
    height: 45,
    cursor: "pointer",
    zIndex: -1,
    color: "red",
  },
  text: {
    zIndex: 0,
    padding: "3px 15px",
    backgroundColor: "white",
    cursor: "pointer",
    opacity: 0.8,
    marginBottom: 5,
  },
  blockName: {
    fontSize: 15,
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
    },
    [theme.breakpoints.down("sm")]: {
      whiteSpace: "nowrap",
    },
  },
  pinContainer: {
    position: "absolute",
    "&:hover": {
      marginTop: -10,
      fontSize: 15,
    },
  },
  contents: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  stageBackground: {
    width: "100%",
    position: "absolute",
    zIndex: -2,
  },
}));

const stages = [
  {
    id: "stage_Stage1",
    name: "Stage 1",
  },
  {
    id: "stage_Stage2",
    name: "Stage 2",
  },
  {
    id: "stage_Stage31",
    name: "Stage 3.1",
  },
  {
    id: "stage_Stage32",
    name: "Stage 3.2",
  },
  {
    id: "stage_Stage33",
    name: "Stage 3.3",
  },
];

const pinLocation = [
  { id: 1, x: 3.4, y: 1.51 },
  { id: 2, x: 2.3, y: 2.6 },
  { id: 3, x: 1.9, y: 4.8 },
  { id: 4, x: 1.9, y: 2 },
  { id: 5, x: 1.65, y: 1.3 },
  { id: 6, x: 1.4, y: 3.1 },
];

function SelectMode() {
  const classes = useStyles();
  const [onActive, setOnActive] = useState("");
  const { height, width } = useWindowDimensions();
  const [blockList, setBlockList] = useState([]);
  const [hovered, setHovered] = useState("");
  const [widthImage, setWidthImage] = useState(0);
  const [heightImage, setHeightImage] = useState(0);
  const theme = useTheme();
  const isWidthXs = useMediaQuery(theme.breakpoints.down("xs"));
  const navigateCases = (block) => {
    setGameBlock(block);
    history.push("/cases");
  };
  const isIpadPro = width / height === 1024 / 1366;
  const isIpad = width / height === 768 / 1024;

  //when user selects the stage
  const handleChange = (event, name) => {
    setOnActive(name);
    // get block / posting options
    if (!!name) {
      getOptions("blockPosting", name.id).then((data) => {
        setBlockList(
          data.slice().sort((a, b) => {
            let firstBlockNum = parseInt(a.id.match(/\d+/)),
              secondBlockNum = parseInt(b.id.match(/\d+/));
            if (firstBlockNum < secondBlockNum) return -1;
            if (firstBlockNum > secondBlockNum) return 1;
            return 0;
          })
        );
        setGameStage(name);
      });
    } else {
      setOnActive("");
    }
  };

  //display block 1/ block 2/ block 3 etc.
  const displayFirst = (name) => {
    let separator = name.split(": ");
    return separator[0];
  };

  //display full name of the block
  const displaySecond = (name) => {
    let separator = name.split(": ");
    return separator[1];
  };

  useEffect(() => {
    let image = document.getElementById("image");
    let widthImageTemp = !!image ? image.offsetWidth : 0;
    let heightImageTemp = !!image ? image.offsetHeight : 0;
    setWidthImage(widthImageTemp);
    setHeightImage(heightImageTemp);
  }, [width, height]);

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.canvas}>
        <GeneralHeader
          //temporary hide back arrow -> add backArrow when back arrow is needed
          //navigate={navigateLoginPage}
          profile
          mode={"Select Stage"}
        />
        <img
          src={fetchImageByName("stageBackground")}
          alt={"stage"}
          className={classes.stageBackground}
          style={{
            height: height - 78,
            minHeight: isWidthXs ? "530px" : "442px",
            minWidth: isIpadPro
              ? "1700px"
              : isIpad
              ? "1300px"
              : width <= 600
              ? "850px"
              : "0px",
          }}
          id={"image"}
        />
        <div
          className={classes.menuDiv}
          style={isWidthXs ? { opacity: hovered === "" ? "1" : "0" } : null}
        >
          <ToggleButtonGroup
            value={onActive}
            orientation="vertical"
            exclusive
            onChange={handleChange}
          >
            {stages.map((stage) => (
              <ToggleButton
                key={stage.id}
                value={stage}
                aria-label={stage.name}
                variant="contained"
                color="primary"
                className={classes.menuButton}
                style={
                  stage === onActive // change button shape when selected
                    ? {
                        color: "black",
                        background: "lightBlue",
                        width: "120%",
                        borderBottomRightRadius: 40,
                      }
                    : null
                }
              >
                {stage.name}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </div>
        <div
          className={classes.contents}
          style={{
            height: height - 78,
            minHeight: isWidthXs ? "530px" : "442px",
            minWidth: isIpadPro
              ? "1700px"
              : isIpad
              ? "1300px"
              : width <= 600
              ? "850px"
              : "0px",
          }}
        >
          <div>
            {blockList.map((item, index) => {
              return (
                <div
                  className={classes.pinContainer} //contains the pin and the text
                  style={{
                    top: heightImage / pinLocation[index].y,
                    left: widthImage / pinLocation[index].x,
                    display:
                      blockList.length === 0 || onActive === ""
                        ? "none"
                        : "block",
                    zIndex: hovered === item ? 2 : 1,
                  }}
                  onMouseEnter={() => {
                    setHovered(blockList[index]);
                  }}
                  onMouseLeave={() => {
                    setHovered("");
                  }}
                >
                  {/*------text-------*/}
                  <div
                    className={classes.text}
                    onClick={() => navigateCases(blockList[index])}
                    style={hovered === item ? { opacity: 1 } : null}
                  >
                    {/*----show only block 1/block 2/block 3 etc.----*/}
                    <Typography
                      className={classes.blockName}
                      style={{ fontSize: hovered === item ? 14 : 13 }}
                    >
                      {blockList[index].name.includes(": ")
                        ? displayFirst(blockList[index].name.toUpperCase())
                        : blockList[index].name.toUpperCase()}
                    </Typography>

                    {/*----when hovered, show full name.----*/}
                    {hovered === item &&
                    blockList[index].name.includes(": ") ? (
                      <Typography className={classes.blockName}>
                        {displaySecond(blockList[index].name.toUpperCase())}
                      </Typography>
                    ) : null}
                  </div>
                  <RoomIcon
                    className={classes.pin}
                    onClick={() => navigateCases(blockList[index])}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SelectMode;
